import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UserService } from '../../_service/user.service';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
import { LabService } from 'src/app/_service/lab.service';
declare var $: any;

@Component({
    selector: 'app-addedit-lab-lead',
    templateUrl: './addedit-lab-lead.component.html',
    styleUrls: ['./addedit-lab-lead.component.css']
})
export class AddeditLabLeadComponent implements OnInit {

    leadForm: FormGroup; submitted = false; loading: boolean = false;cities = []; cities_copy = [];
     labTest = []; labTest_copy = []; labBds = []; labBds_copy = [];test_subcategory:boolean=true;labTestSubcategory =[];
     labTestSubcategory_copy =[];lead_sources=[];checkLeadData=[];

    constructor(private labapi: LabService, private router: Router, private sharedapi: SharedService, private formBuilder: FormBuilder, public leadapi: LeadsService, private activatedRoute: ActivatedRoute) {

        this.getcitiesList();
        this.getLabTestCategory();
        this.getLabBds();
        this.getLeadSources();

        let contactPattern = "[[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*]*";
        this.leadForm = this.formBuilder.group({
            'name': [null, Validators.required],
            'mobile': [null, Validators.compose([Validators.required, Validators.pattern(contactPattern)])],
            'city_id': [null, Validators.required],
            'lead_source': [null, Validators.required],
            'lab_test_category': [null, Validators.required],
            'lab_test_subcategory': [null, Validators.required],
            'user_id': [null, Validators.required]
        });

    }

    async getLeadSources()
    {
        this.leadapi.getLeadSources().subscribe((data:any) => {
            if(data.status)
            {
                this.lead_sources = data.data;
            }else{
                this.lead_sources = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    
        
    }

    sortFunc(a, b) {
        return 1;
    }

    get f() { return this.leadForm.controls; }

    setSearchValue(type) {
        if (type == 'city') {
            $("#citySearch").val('');
            $("#citySearch").focus();
            this.cities = this.cities_copy;
        } else if (type == 'labtest') {
            $("#testSearch").val('');
            $("#testSearch").focus();
            this.labTest = this.labTest_copy;
        } else if (type == 'user') {
            $("#userSearch").val('');
            $("#userSearch").focus();
            this.labBds = this.labBds_copy;
        } 
        else if (type == 'labtestsub') {
            $("#categorySearch").val('');
            $("#categorySearch").focus();
            this.labTestSubcategory = this.labTestSubcategory_copy;
        }
    }

    searchOnSelect(searchtText: string, type) {
        if (type == 'city') {
            this.cities = this.sharedapi.searchData(searchtText, this.cities_copy, "name");
        } else if (type == 'labtest') {
            this.labTest = this.sharedapi.searchData(searchtText, this.labTest_copy, "name");
        } else if (type == 'user') {
            this.labBds = this.sharedapi.searchData(searchtText, this.labBds_copy, "name");
        } else if (type == 'labtestsub') {
            this.labTestSubcategory = this.sharedapi.searchData(searchtText, this.labTestSubcategory_copy, "name");
        }

    }

    async getcitiesList() {
        await this.leadapi.getcities().subscribe((data: any) => {
            if (data.status) {
                this.cities = data.data;
                this.cities_copy = this.cities;
            } else {
                this.cities = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getLabTestCategory() {
        await this.labapi.getLabTestCategory().subscribe((data: any) => {
            if (data.status) {
                this.labTest = data.data;
                this.labTest_copy = this.labTest;
            } else {
                this.labTest = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    
    async getLabTestCategorySubcategory(lab_test_id)
    {
        console.log("lab_test_id",lab_test_id);
        let qString = 'lab_test_id='+lab_test_id;
        await this.labapi.getLabTestCategorySubcategory(qString).subscribe((data:any) => {
            if(data.status)
            {
                this.labTestSubcategory = data.data;
                this.labTestSubcategory_copy = this.labTestSubcategory;
                this.test_subcategory=false;
            }else{
                this.labTestSubcategory = [];
                this.test_subcategory=false;
            }
        }, error => {
            this.sharedapi.checkError(error);
        });

    }

    async getLabBds() {
        await this.labapi.getLabBds().subscribe((data: any) => {
            if (data.status) {
                this.labBds = data.data;
                this.labBds_copy = this.labBds;
            } else {
                this.labBds = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }


    ngOnInit(): void {}


    async addLead() {

        this.submitted = true;
        this.loading = true;
        // stop here if form is invalid
        if (this.leadForm.invalid) {
            this.loading = false;
            return;
        }
        //For Add Lead//
        await this.labapi.addLead(this.leadForm.value)
            .subscribe((data: any) => {
                this.submitted = false;
                this.loading = false;
                if (data.status) {
                    this.sharedapi.presentToast('Lead Added Successfully');
                    this.router.navigateByUrl('/lab-sheetview');
                }
                else {
                    this.sharedapi.presentToast(data.msg);
                }
            }, error => {
                this.sharedapi.checkError(error);
            });

    }


    async checkMobile()
    {
        let mobile = this.leadForm.controls['mobile'].value;
        let data = {
            'mobile': mobile
          };
        await this.labapi.checkLabLeadMobileNumber(data).subscribe((data:any) => {
            if(data.status)
            {
                this.showModal();
                this.checkLeadData = data.data;
            }else{
                this.checkLeadData = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    hideModal()
    {
        $('#myModal').modal('hide');
    }

    showModal()
    {
        $('#myModal').modal();
    }

}
